import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import { LINK_PPROLLS_SETUP } from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const PPRollsListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.PPROLLS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }
  const getOpText = (tableName, itemID) => {
    const itemRec = store.options.has(tableName) && store.options.get(tableName).find(i => i.value === itemID)
    return itemRec && itemRec.text ? itemRec.text : itemID
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />),
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('pprollsConditions')}
      labelattr='label'
      valueattr='value' />),
    (attr, row) => {
      const conditionTable = row && row.condition_table
      const component = ({ text }) => {
        if (conditionTable === 'platforms') {
          const i = store.options.has('FlyPrivatePlatforms') && store.options.get('FlyPrivatePlatforms').find(i => i.value === text)
          return i ? `${i.text}` : text
        } else if (conditionTable === 'categories') {
          const i = store.options.has('FlyprivateCategories') && store.options.get('FlyprivateCategories').find(i => i.value === text)
          return i ? `${i.text}` : text
        } else if (conditionTable === 'homepage') {
          const i = store.options.has('flyprivate_homepage_settings') && store.options.get('flyprivate_homepage_settings').find(i => i.id === parseInt(text))
          return i ? `${getOpText('FlyPrivatePlatforms', i.fp_platform_code)}
            | ${getOpText('FlyprivateCategories', i.fp_category_code)}
            | ${getOpText('FlyPrivateCategoryTypes', i.fp_category_type)}
            | ${i.valid_from} | ${i.valid_to} | ${i.id}` : text
        } else if (conditionTable === 'tiers') {
          const i = store.options.has('flyprivate_all_tiers') && store.options.get('flyprivate_all_tiers').find(i => i.id === parseInt(text))
          return i ? `${getOpText('FlyPrivatePlatforms', i.platform)} | ${getOpText('PricingTiers', i.tier)} | ${i.type_sale} | ${i.id}` : text
        } else if (conditionTable === 'pricings') {
          const i = store.options.has('flyprivate_all_pricings') && store.options.get('flyprivate_all_pricings').find(i => i.id === parseInt(text))
          const ii = i && store.options.has('flyprivate_all_tiers') && store.options.get('flyprivate_all_tiers').find(j => j.id === parseInt(i.flyprivate_platform_tier_id))
          return i ? `tier: ${ii.id} - ${ii.type_sale} - ${getOpText('PricingTiers', ii.tier)} - ${ii.type_sale} | ${i.currency_cd} | ${i.quality_sd_price} | ${i.regions} | ${i.valid_from} | ${i.valid_to} | ${i.id}` : text
        } else if (conditionTable === 'film') {
          const i = store.options.has('films') && store.options.get('films').find(i => i.id === parseInt(text))
          return i ? `${i.title} | ${i.id}` : text
        } else {
          return text
        }
      }
      return <TextField attr={attr} val={row[attr]} Component={component} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} Component={() => (<span> {row.s3_filename} | {row.original_filename}</span>)}/>),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField
      attr={attr} val={row[attr] || '-'}
      options={store.options.get('Countries')} labelattr='text'
      popoverText={row[attr] && row[attr].replace(/,/g, ', ')} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.items_valid_to} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.items_valid_from} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  const filters = {
    id_like: {
      component: (props) => (<TextInput {...props} />)
    },
    name_like: {
      component: (props) => (<TextInput {...props} />)
    },
    valid_from__from: {
      component: (props) => (
        <div style={{ width: '100px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    valid_to__from: {
      component: (props) => (
        <div style={{ width: '100px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    condition_table_like: {
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        valueFilterFc={i => defaultConst.PPROLLS_HIDDEN_OPTIONS.indexOf(i.value) > -1 }
        labelattr='label' valueattr='value' optionsattr={'pprollsConditions'} />)
    },
    position_like: {
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='value' valueattr='value' optionsattr={'playPosition'} />)
    },
    use_for_like: {
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='value' valueattr='value' optionsattr={'playUseFor'} />)
    },
    regions_like: {
      component: (props) => (<TextInput {...props} />)
    },
    items_valid_from__from: {
      component: (props) => (
        <div style={{ width: '100px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    items_valid_to__from: {
      component: (props) => (
        <div style={{ width: '100px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_PPROLLS_SETUP)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />)
}
export default observer(PPRollsListView)
